import React, { useContext } from "react";
import { AudioSchedulerContext } from "./audioSchedulerContext";

const MutedContext = React.createContext<MutedContextType>([false, (muted: boolean) => {}])

export const MutedProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) =>  {
    const [muted, setMutedState] = React.useState(false);
    const [audioScheduler] = useContext(AudioSchedulerContext);

    const setMuted = (value: boolean) => {
        audioScheduler.mute(value);
        setMutedState(value);
    };

    return (
        <MutedContext.Provider value={[muted, setMuted]}>
            {children}
        </MutedContext.Provider>
    );
};

export const useMuted = () => {
    const [muted, setMuted] = React.useContext(MutedContext);
    return [muted, setMuted] as MutedContextType;
};

export type MutedContextType = [boolean, (muted: boolean) => void];